"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.skillsExtractor = exports.successExtractor = exports.skillExtractor = void 0;
var skillExtractor = function (response) { return response.skill; };
exports.skillExtractor = skillExtractor;
var successExtractor = function (response) { return response.success; };
exports.successExtractor = successExtractor;
var skillsExtractor = function (response) { return response.skills; };
exports.skillsExtractor = skillsExtractor;
//# sourceMappingURL=Skills.consts.js.map